"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.joinArrays = exports.getRangeLimits = exports.getMultilineLimits = exports.VVarrtoDBarr = exports.VAarrtoDBarr = void 0;
var Conversion = _interopRequireWildcard(require("./conversion"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const joinArrays = function (array1, array2) {
  var length = Math.min(array1.length, array2.length);
  var result = [];
  for (var n = 0; n < length; n++) {
    result.push([array1[n], array2[n]]);
  }
  return result;
};
exports.joinArrays = joinArrays;
const VVarrtoDBarr = function (vvArr) {
  var vvArray = [];
  var dbArray = new Array();
  if (vvArr) {
    vvArray = vvArr; // putting the values of input vvArr to a new array vvArray.
    var len = vvArray.length;
    for (var i = 0; i < len; i++) {
      dbArray[i] = Conversion.VVtoDB(vvArray[i]);
    }
  }
  return dbArray;
};
exports.VVarrtoDBarr = VVarrtoDBarr;
const VAarrtoDBarr = function (vaArray) {
  var dbArray = new Array(); // declaring the dbArray

  if (vaArray) {
    var len = vaArray.length;
    for (var i = 0; i < len; i++) {
      dbArray[i] = Conversion.VAtoDB(vaArray[i]);
    }
  }
  return dbArray;
};
exports.VAarrtoDBarr = VAarrtoDBarr;
const getRangeLimits = function (graphData) {
  var model = graphData;
  var minx = Math.min(...model.map(x => x[0]));
  var maxx = Math.max(...model.map(x => x[0]));
  var miny = null;
  var maxy = null;
  if (graphData[0].length === 2) {
    miny = Math.min(...model.map(x => x[1]));
    maxy = Math.max(...model.map(x => x[1]));
  } else {
    var yValues = [];
    model.forEach(x => {
      yValues.push(x[1]);
      yValues.push(x[2]);
      yValues.push(x[3]);
    });
    miny = Math.min(...yValues);
    maxy = Math.max(...yValues);
  }
  var result = {
    xmin: minx,
    xmax: maxx,
    ymin: miny,
    ymax: maxy
  };
  return result;
};
exports.getRangeLimits = getRangeLimits;
const getMultilineLimits = function (graphDataList) {
  let limitsList = [];
  graphDataList.forEach(element => {
    if (element.length > 2) {
      let elemLimit = getRangeLimits(element);
      limitsList.push(elemLimit);
    }
  });
  let limits = [];
  limitsList.forEach(element => {
    limits.push([element.xmin, element.ymin]);
    limits.push([element.xmax, element.ymax]);
  });
  let limitsResult = getRangeLimits(limits);
  if (limitsResult.ymin == 0) {
    let yValues = limits.map(x => x[1]).filter(x => x != 0);
    limitsResult.ymin = Math.min(...yValues);
  }
  return limitsResult;
};
exports.getMultilineLimits = getMultilineLimits;